let awsConfigs = {
    CognitoIdentityPoolId: process.env.AWS_COGNITO_IDENTITY_POOL_ID,
    S3VideoRegion: process.env.AWS_REGION,
    S3VideoBucket: process.env.AWS_BUCKET,
}

module.exports = {
    awsConfigs
}